import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reportingEffects } from 'src/app/root-store/reporting-store/effects';
import { reportingReducer } from './reducers';
import { reportingFeatureKey } from './reporting.state';

@NgModule({
    imports: [StoreModule.forFeature(reportingFeatureKey, reportingReducer), EffectsModule.forFeature(reportingEffects)]
})
export class ReportingStoreModule {}
